const state = {
    cards: [],
    stripePublishableKey: null,
    stripeApiVersion: null,
};

const getters = {
    cards: state => state.cards,
    defaultCard: state => state.cards.find(card => card.default_card) || state.cards[0],
    validCards: state => state.cards.filter(card => {
        return card.address && card.expiry_date && card.last_four && card.token && card.fingerprint;
    }),
};

// mutations
const mutations = {
    setCards: (state, cards) => state.cards = cards,
    stripePublishableKey: (state, stripePublishableKey) => state.stripePublishableKey = stripePublishableKey,
    stripeApiVersion: (state, stripeApiVersion) => state.stripeApiVersion = stripeApiVersion,
};

export default {
    namespaced: true,
    state,
    getters,
    mutations
}
